import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";

// Img
import selfieImg from '../assets/svg/boy-taking-selfie.svg'

//css
import classes from "../pages/Profile/Profile.module.css";

// Jds
import { AvatarV2, BadgeV2, Button, Container, Icon, Notifications, Text } from "@jds/core";

//Mui
import { Box, Stack } from "@mui/material";

// Local
import JdsModal from "../components/UI/JdsModal";
import { authActions } from "../store/state-slices/auth";
import PageLoader from "../components/UI/Loader/PageLoader";
import ProfileDetailForm from "../components/UI/Form/ProfileDetailForm";
import { updateProfileDetails } from "../store/state-slices/profileDetails";
import useApiHttp from "../hooks/use-http";
import { addParamsURL } from "../util/helper";
import AvatarView from "../components/UI/Views/avatarView/AvatarView";
import SecondaryProfileDetailForm from "../components/UI/Form/SecondaryProfileForm";
import ProfileFormSkeleton from "../components/UI/Form/ProfileFormSkeleton";

const profileContentCss = {
  position: 'relative',
  borderRadius: '16px',
  backgroundColor: 'var(--color-primary-20)',
  padding: '16px',
  '@media screen and (max-width: 767px)': {
    display: 'none'
  }
}

const ProfileCard = ({ data, onEditClick, onDeleteClick, isDeletable = true, ...props }) => {
  return (
    <Box className={classes['profile__card']} {...props?.cardProps}>
      {props?.label &&
        <Box mb={2}>
          <BadgeV2 label="Primary" size="large" color="positive" informationKind="label" appearance="subtle" />
        </Box>
      }
      <Stack direction="row" justifyContent="space-between" alignItems={"center"}>
        <Stack direction="row" gap={2} alignItems={'center'}>
          <AvatarView
            size="large"
            kind="image"
            image={
              data?.profilePictureThumbnail ?
                addParamsURL(
                  data?.profilePictureThumbnail,
                  {
                    size: "s",
                  }
                )
                : ""
            }
          />
          <div>
            <Text text={data?.firstName} appearance="body-m-bold" />
            {/* <Container gap={8} verticalAlign="center">
              <Text text={data?.firstName} appearance="body-m-bold" />
              {props?.label &&
                <Box>
                  <BadgeV2 label="Primary" size="large" color="positive" informationKind="label" appearance="subtle" />
                </Box>
              }
            </Container> */}
            <Text text={data?.relationName || ""} appearance="body-s" color="primary-grey-80" />
          </div>
        </Stack>
        <Stack direction="row" gap={1}>
          <Icon ic={'IcEdit'} color="primary_grey_80" onClick={() => onEditClick()} />
          {isDeletable && <Icon ic={'IcTrash'} color="primary_grey_80" onClick={() => onDeleteClick()} />}
        </Stack>
      </Stack>
    </Box>
  )
}

const EditProfile = ({ }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails
  );
  const [isProfileDeleteModalClose, setProfileDeleteModalClose] = useState(true)
  const [secondaryProfileList, setSecondaryProfileList] = useState([])
  const [availableSecondaryProfileList, setAvailableSecondaryProfileList] = useState([])
  const [selectedSecondaryProfile, setSelectedSecondaryProfile] = useState(null)
  const [deleteProfileId, setDeleteProfileId] = useState(null)
  const [isPrimaryFormOpen, setPrimaryFormOpen] = useState(true)
  const [isAddFormOpen, setIsAddFormOpen] = useState(false)
  const [isFormClosed, setIsFormClosed] = useState(false)
  const [isProfileUpdating, setIsProfileUpdating] = useState(false)

  const { isLoading: isGettingProfile, sendRequest: getProfile } = useApiHttp();
  const { isLoading: isGettingAvailableSecondaryProfile, sendRequest: getAvailableSecondaryProfile } = useApiHttp();
  const { isLoading: isGettingAllSecondaryProfile, sendRequest: getAllSecondaryProfile } = useApiHttp();
  const { isLoading: iseditingSecondaryProfile, sendRequest: editSecondaryProfile } = useApiHttp();
  const { isLoading: isDeletingSecondaryProfile, sendRequest: deleteSecondaryProfile } = useApiHttp();


  const getAllSecondaryProfileHandler = (addedRelationId) => {
    getAllSecondaryProfile(
      {
        url: 'manage-profiles/get-all',
        base: 'AUTH',
      },
      null,
      (data) => {
        setSecondaryProfileList(data?.data?.secondaryProfileDetails.map(val => (
          { ...val, id: val?.secondaryProfileId }
        )))

        // Add created profile to selected profile
        if (isAddFormOpen) {
          if (data?.data?.secondaryProfileDetails.length > 0) {
            const newSecondaryProfile = data?.data?.secondaryProfileDetails.find(val => val?.relationId === addedRelationId)
            setSelectedSecondaryProfile({ ...newSecondaryProfile, id: newSecondaryProfile?.secondaryProfileId })
          }
        }

        // edit secondary profile in the secondary profile list state
        let updatedSecondaryProfile;
        if (selectedSecondaryProfile) {
          updatedSecondaryProfile = data?.data?.secondaryProfileDetails.find(val => val.secondaryProfileId === selectedSecondaryProfile?.id)
          console.log(updatedSecondaryProfile)
          setSelectedSecondaryProfile({ ...updatedSecondaryProfile, id: updatedSecondaryProfile?.secondaryProfileId })
        }
      },
      () => { },
    )
  }

  const getAvailableSecondaryProfileHandler = () => {
    getAvailableSecondaryProfile(
      {
        url: 'secondary-profile/available-relations',
        base: 'AUTH',
      },
      null,
      (data) => {
        setAvailableSecondaryProfileList(data?.data)
      },
      () => { },
    )
  }

  const editSecondaryProfileHandler = (id) => {
    editSecondaryProfile(
      {
        url: `secondary-profile/${id}`,
        base: 'AUTH',
      },
      null,
      () => { },
      () => { },
    )
  }

  const deleteSecondaryProfileHandler = (id) => {
    deleteSecondaryProfile(
      {
        url: `secondary-profile/${id}`,
        base: 'AUTH',
        method: 'DELETE'
      },
      null,
      (data) => {
        Notifications.toast.success({ id: 'delete secondary user', title: data?.message })
        setSecondaryProfileList(pre => pre.filter(val => val?.id !== deleteProfileId))
        setProfileDeleteModalClose(true)
        if (selectedSecondaryProfile?.id === deleteProfileId) {
          setIsFormClosed(true)
        }
      },
      (err, data) => {
        Notifications.toast.error({ id: 'delete secondary user', title: data?.message })
      },
    )
  }

  const secondaryProfileEditClickHandler = (val) => {
    setSelectedSecondaryProfile(val)
    setPrimaryFormOpen(false)
  }

  useEffect(() => {
    getAllSecondaryProfileHandler()
  }, []);

  useEffect(() => {
    getAvailableSecondaryProfileHandler()
  }, [secondaryProfileList]);

  // useEffect(() => {
  //   if (!profileDetailsRedux?.phoneNumber) {
  //     navigate("/home");
  //   }
  // }, []);
  return (
    <>
      <Box className="custom-scrollbar">
        <Box mb={3}>
          {/* <Text text={`${profileDetailsRedux?.userType !== 'SCHOOL' ? 'Manage' : 'Edit'} Profile`} appearance="body-l-bold" /> */}
          <Text text={'Manage Profile'} appearance="body-l-bold" />
        </Box>

        {profileDetailsRedux?.userType !== 'SCHOOL' ?
          // Multip profile container
          <Stack direction={'row'} gap={6} alignItems={'flex-start'}>
            <Stack direction="column" gap={2} flex={0.3} sx={{
              '& .j-JDSButton-container': {
                borderRadius: '12px',
                borderColor: 'var(--color-primary-grey-60)',
                padding: '20px'
              }
            }}>
              <ProfileCard
                data={{
                  ...profileDetailsRedux,
                  profilePictureThumbnail: profileDetailsRedux?.profilePictureThumbnailUrl,
                  relationName: 'You'
                }}
                label={true}
                onEditClick={() => {
                  setIsFormClosed(false)
                  setPrimaryFormOpen(true)
                }}
                isDeletable={false}
              />
              {secondaryProfileList.length > 0 &&
                secondaryProfileList.map((val, i) => {
                  return <ProfileCard
                    key={val?.id}
                    data={val}
                    onEditClick={() => {
                      setIsFormClosed(false)
                      secondaryProfileEditClickHandler(val)
                      setIsAddFormOpen(false)
                    }}
                    onDeleteClick={() => {
                      setProfileDeleteModalClose(false)
                      setDeleteProfileId(val?.id)
                      setIsAddFormOpen(false)
                    }
                    } />
                })
              }
              {availableSecondaryProfileList.length > 0 &&
                <Button label={'Add Profile'} iconLeft={'IcAdd'} kind="secondary" size="large" fullWidth onClick={() => {
                  setIsFormClosed(false)
                  setPrimaryFormOpen(false)
                  setSelectedSecondaryProfile(null)
                  setIsAddFormOpen(true)
                }} />
              }
            </Stack>
            {!isFormClosed &&
              <div
                style={{
                  maxWidth: "420px",
                  flex: 1
                }}
              >
                {
                  <>
                    <Box mb={3}>
                      <Text text={`${isAddFormOpen && !isPrimaryFormOpen ? 'Add' : 'Edit'} Profile`} appearance="body-m-bold" />
                    </Box>
                    {isPrimaryFormOpen &&
                      <ProfileDetailForm
                        updateProfile={() => {
                          getProfile(
                            {
                              base: "AUTH",
                              url: `profile`,
                              method: "GET",
                            },
                            null,
                            (data) => {
                              dispatch(
                                updateProfileDetails({
                                  profileDetails: data?.data,
                                })
                              );
                            }
                          );
                        }}
                      />}

                    {!isPrimaryFormOpen &&
                      <SecondaryProfileDetailForm
                        data={selectedSecondaryProfile}
                        availableRelationList={availableSecondaryProfileList}
                        updateProfile={(val) => {
                          getAllSecondaryProfileHandler(val?.relationId)
                          setIsAddFormOpen(false)
                        }}
                        onDeleteClick={(val) => {
                          setProfileDeleteModalClose(false)
                          setDeleteProfileId(val?.id)
                          setIsAddFormOpen(false)
                        }}
                        isAddForm={isAddFormOpen}
                        isDeletable={!isAddFormOpen}
                      />
                    }
                  </>
                }
              </div>
            }
          </Stack>
          :
          <Stack direction={'row'} gap={4} alignItems={'flex-start'}>
            <div
              style={{
                maxWidth: "420px",
                flex: 1
              }}
            >
              <ProfileDetailForm
                updateProfile={() => {
                  getProfile(
                    {
                      base: "AUTH",
                      url: `profile`,
                      method: "GET",
                    },
                    null,
                    (data) => {
                      dispatch(
                        updateProfileDetails({
                          profileDetails: data?.data,
                        })
                      );
                    }
                  );
                }}
              />
            </div>
            <Box sx={{ ...profileContentCss, '& img': { width: '50%', position: 'absolute', right: '-20%', bottom: '-16px', } }}>
              <img src={selfieImg} />
              <Box pr={'20%'}>
                <Box mb={2}>
                  <Text text="Stand Out!" appearance="heading-xs" />
                </Box>
                <Text text="Upload a clear photo to help others recognize you and connect easily." appearance="body-s" color="primary-grey-80" />
                <Text text="Keep your email updated to receive event invites and messages from other users." appearance="body-s" color="primary-grey-80" />
              </Box>
            </Box>
          </Stack>
        }

        {/* <Stack direction={'row'} gap={4} alignItems={'flex-start'}>
          <div
            style={{
              maxWidth: "420px",
              flex: 1
            }}
          >
            <ProfileDetailForm
              updateProfile={() => {
                getProfile(
                  {
                    base: "AUTH",
                    url: `profile`,
                    method: "GET",
                  },
                  null,
                  (data) => {
                    dispatch(
                      updateProfileDetails({
                        profileDetails: data?.data,
                      })
                    );
                  }
                );
              }}
            />
          </div>
          <Box sx={{ ...profileContentCss, '& img': { width: '50%', position: 'absolute', right: '-20%', bottom: '-16px', } }}>
            <img src={selfieImg} />
            <Box pr={'20%'}>
              <Box mb={2}>
                <Text text="Stand Out!" appearance="heading-xs" />
              </Box>
              <Text text="Upload a clear photo to help others recognize you and connect easily." appearance="body-s" color="primary-grey-80" />
              <Text text="Keep your email updated to receive event invites and messages from other users." appearance="body-s" color="primary-grey-80" />
            </Box>
          </Box>
        </Stack> */}

      </Box>
      <PageLoader open={isGettingProfile} />
      <JdsModal
        size="m"
        header="Are you sure you want to delete this user?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isProfileDeleteModalClose}
        onClose={() => setProfileDeleteModalClose(true)}
        onPrimaryClick={() => {
          deleteSecondaryProfileHandler(deleteProfileId)
        }}
        onSecondaryClick={() => {
          setProfileDeleteModalClose(true)
        }}
        primaryCtaDisabled={isDeletingSecondaryProfile}
      />
    </>
  );
};

export default EditProfile;
